import { Button } from 'primereact/button';
import { confirmDialog } from 'primereact/confirmdialog';
import { Message } from 'primereact/message';
import Data from '../../../../components/Display/Data';
import MultiLineData from '../../../../components/Display/MultiLineData';
import Section from '../../../../components/Display/Section';
import Tag from '../../../../components/Display/Tag';
import ImageItem from '../../common/image/ImageItem';

function ProjectDetail({
  project,
  handleUpdateProject,
  handleUpdateHeaderImages,
  handleUpdateOtherImages,
  handleDelete
}) {
  const updateProjectActions = [
    {
      onClick: handleUpdateProject,
      label: 'Modifier les informations',
      icon: 'pi-pencil'
    }
  ];

  const headerImageActions = [
    {
      onClick: () => handleUpdateHeaderImages(),
      label: 'Modifier les images',
      icon: 'pi-pencil'
    }
  ];

  const otherImagesActions = [
    {
      onClick: handleUpdateOtherImages,
      label: 'Modifier les images',
      icon: 'pi-pencil'
    }
  ];

  const confirmDeletion = (project) => {
    confirmDialog({
      message: 'Êtes-vous sûr de vouloir supprimer ce Projet ?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Oui',
      rejectLabel: 'Annuler',
      accept: () => handleDelete(project)
    });
  };

  return (
    <div className="h-full w-full flex-col flex gap-5">
      <Section label="Informations Générales" actions={updateProjectActions}>
        <div className="flex flex-wrap gap-5">
          <Data key="title" label={'Titre'} value={project.title} large translatable />
          <Data key="year" label={'Année'} value={project.year} />
          <Tag
            tag={{
              label: project.is_highlight && 'Projet mis en avant',
              icon: 'star',
              bgColor: project.is_highlight && 'bg-purple-800'
            }}
            rounded
          />
        </div>
        <div className="flex flex-row flex-wrap gap-5">
          <Data key="country" label={'Pays'} value={project.localisation.country} />
          <Data key="city" label={'Ville'} value={project.localisation.city} />
          {project.is_highlight && (
            <Data key="surface" label={'Surface'} value={project.surface} suffix={'m²'} />
          )}
        </div>
        {project.is_highlight && (
          <div className="flex flex-row gap-5">
            <MultiLineData
              key="description"
              label={'Description'}
              value={project.description}
              large
              asHtml
              translatable
            />
            <MultiLineData
              key="review"
              label={'Avis Client'}
              value={project.review}
              large
              asHtml
              translatable
            />
          </div>
        )}
      </Section>

      <Section label="Image Principale">
        {!project?.main_image ? (
          <span className="italic text-slate-400 font-light">Aucune image à afficher</span>
        ) : (
          <ImageItem
            image={project?.main_image}
            alt={project.title}
            className="h-60 w-fit"
            ratio={1.5}
          />
        )}
      </Section>
      {project.is_highlight && (
        <Section label="Images d'en-tête" actions={headerImageActions}>
          {project.header_images.length < 2 && (
            <Message
              severity="error"
              text="Le projet ne pourra pas être publié sans les 2 images d'en-tête"
              className="w-fit"
            />
          )}
          <div className={`flex flex-wrap gap-3`}>
            {!project.header_images.length ? (
              <span className="italic text-slate-400 font-light">Aucune image à afficher</span>
            ) : (
              project.header_images.map((img, index) => (
                <ImageItem
                  key={index}
                  image={img}
                  alt={`Photo de ${project.title} n°${index}`}
                  className="h-60"
                />
              ))
            )}
          </div>
        </Section>
      )}
      {project.is_highlight && (
        <Section label="Autres images" actions={otherImagesActions}>
          <div className={`flex flex-wrap gap-3`}>
            {!project.other_images.length ? (
              <span className="italic text-slate-400 font-light">Aucune image à afficher</span>
            ) : (
              project.other_images.map((img, index) => (
                <ImageItem
                  key={index}
                  image={img}
                  alt={`Photo de ${project.title} n°${index}`}
                  className="h-60"
                />
              ))
            )}
          </div>
        </Section>
      )}

      <Section label="Autres actions">
        <div>
          <Button
            key={'delete'}
            label={'Supprimer le projet'}
            className="!w-54"
            outlined
            onClick={() => confirmDeletion(project)}
            severity="danger"
          />
        </div>
      </Section>
    </div>
  );
}

export default ProjectDetail;
